import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 13 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 10\" id=\"star\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.14727 3.90412L6.54803 0.444458L5.01607 3.78742H0.285645L4.04308 6.06537L2.7906 10L6.54803 7.75164L10.3055 10L9.05299 6.06537L12.8104 3.78742L8.14727 3.90412Z\" fill=\"#EBEBEB\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol